import React from 'react'
import { Row, Col} from 'antd'
import Neckless from '../images/nicklesback.png'
import Arrow1 from '../images/arrow1.png'





const AboutsBanner = ({data}) => {
    return (
        <div>
            <section className='aboutbanners'>
                <div className="container">
                    <div className="mainAbouts">
                    <Row
            gutter={[30, 30]} // Add vertical gutter for spacing between rows
            align="middle" // Align items vertically to the center
        >
            {/* About Us Text Column */}
            <Col xs={24} sm={24} md={24} lg={15} xl={15}>
                <div className="themeAbout">
                    <h2>{data.title}</h2>
                    {data.description.map((item, ind) => <p key={ind}>{item}</p>)}
                </div>
            </Col>

            {/* Image and Button Column */}
            <Col xs={24} sm={24} md={24} lg={9} xl={9}>
                <div className="themeaboutus">
                    <img src={data.image} alt="img" style={{ width: '100%', height: 'auto' }} />
                    <div className="aboutbuttonin">
                        <h3>{data.cardTitle}</h3>
                        <button>
                            Shop Now <img src={Arrow1} alt="arrow" />
                        </button>
                    </div>
                </div>
            </Col>
        </Row>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AboutsBanner
